import { Transition } from '@headlessui/react';
import { AxiosError } from 'axios';
import React, { useState } from 'react';
import { FaCheck } from 'react-icons/fa';
import { useGetUserProfile } from '../api/userprofile';
import ProfileInformationForm from './ProfileInformationForm';
import WelcomeInfoPane from './WelcomeInfoPane';

export const GatekeeperModal = () => {
  const { isError, refetch, error } = useGetUserProfile();
  const status = (error as AxiosError)?.response?.status;
  const [isDoneSaving, setIsDoneSaving] = useState(false);
  const handleAnimationEnd = () => {
    // Give the user a bit of time to read the message before closing the modal
    setTimeout(() => refetch(), 1500);
  };

  return (
    <Transition
      className="absolute top-0 left-0 z-50 flex items-center justify-center w-screen h-screen p-10 transition-opacity duration-300 bg-black bg-opacity-50"
      enterFrom="opacity-0"
      enterTo="opacity-100"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
      show={isError && status === 404}
    >
      {/* TODO add a tw3 max-h on here to look better on big screens */}
      <div className="w-full h-full overflow-hidden overflow-y-auto bg-white shadow-lg lg:max-w-6xl rounded-xl lg:h-auto max-h-screen">
        <h1 className="py-2 pl-3 text-xl font-semibold border-b bg-gray-50">Create Your Profile</h1>
        <div className="flex flex-col p-6 justify-evenly lg:flex-row">
          <Transition
            show={isDoneSaving}
            className="absolute top-0 left-0 flex items-center justify-center w-full h-full p-10 transition-all duration-300 delay-700"
            appear={true}
            enterFrom="opacity-0"
            enterTo="opacity-100"
            afterEnter={handleAnimationEnd}
          >
            <FaCheck className="mr-3 text-3xl text-green-600" />
            <div>
              <h2 className="text-2xl font-semibold">Thanks for updating your information</h2>
              <h3 className="text-xl text-gray-600">
								You&#39;re all set to start making requests for OncoLens{' '}
                <span className="italic">Collaborate</span>.
              </h3>
            </div>
          </Transition>

          <Transition
            show={!isDoneSaving}
            className="transition-all duration-700 lg:w-5/12"
            enterFrom=""
            enterTo=""
            leaveFrom="opacity-100 transform translate-y-0"
            leaveTo="opacity-0 transform translate-y-2"
          >
            <WelcomeInfoPane />
          </Transition>
          <Transition
            show={!isDoneSaving}
            className="pt-3 transition-all duration-500 delay-200 lg:w-5/12 lg:pt-0"
            enterFrom=""
            enterTo=""
            leaveFrom="opacity-100 transform translate-y-0"
            leaveTo="opacity-0 transform translate-y-2"
          >
            <h2 className="mb-2 text-2xl font-semibold">Profile</h2>
            <p>
							Please provide your profile information. This will be sent with your collaboration
							requests.
            </p>
            <ProfileInformationForm onCompleted={() => setIsDoneSaving(true)} />
          </Transition>
        </div>
      </div>
    </Transition>
  );
};
